import apiClient from "./apiClient";
import { CreateNotification } from "../components/notification/Notification";

export const MaxInputLength = 255;

export const AreNotesLessThanMaxLength = (notes = []) => {
  let invalidItems = []
  notes.forEach(n => {
    let isNotesValid = true
    isNotesValid = (n.note?.length ?? 0) <= MaxInputLength;
    if (!isNotesValid) {
      invalidItems.push(n?.name)
    }
  })
  return invalidItems;
}

export const ToCamelCase = (name) => {
  let camelCase = name.charAt(0).toUpperCase() + name.slice(1);

  if (camelCase === 'Liner') {
    camelCase += 's';
  } else if (camelCase === 'Foot') {
    camelCase = 'Feet'
  }

  return camelCase;
}

export const GetAccountPermission = async (accountNumber, permissionName) => {
  if (!accountNumber || !permissionName) {
    console.warn("GetAccountPermission called with missing arguments", { accountNumber, permissionName });
    return false;
  }

  try {
    const response = await apiClient.get(`permission/${accountNumber}`);
    const permissions = response?.data;

    if (!Array.isArray(permissions) || permissions.length === 0) {
      return false;
    }

    return permissions.some((permission) => permission.permissionName === permissionName);
  } catch (error) {
    console.error(`Failed to fetch permissions for account ${accountNumber}:`, error);
    return false;
  }
};

export const IsInputExcessive = (e, id) => {
  const input = e.target.value;
  let doesExceedLength = false;
  let maxLength = 0;
  let fieldName = "";

  var currentRestriction = FIELD_CONFIG[id];
  if (currentRestriction) {
    maxLength = currentRestriction.maxLength;
    fieldName = currentRestriction.fieldName;
    if (maxLength && input?.length > maxLength) {
      doesExceedLength = true;
      CreateNotification(`The "${fieldName}" field cannot exceed ${maxLength} characters`, "error");
    }
  }

  return doesExceedLength;
}

const FIELD_CONFIG = {
  "accountNumber": { "maxLength": 10, "fieldName": "Account Number" },
  "patientId": { "maxLength": 50, "fieldName": "Patient Id" },
  "prosthetistName": { "maxLength": 40, "fieldName": "Clinician Name" },
  "clinicName": { "maxLength": 40, "fieldName": "Clinic Name" },
  "email": { "maxLength": 40, "fieldName": "Email Address" },
  "poNumber": { "maxLength": 15, "fieldName": "PO Number" },
  "shippingAddress1": { "maxLength": 40, "fieldName": "Shipping Address line 1" },
  "shippingAddress2": { "maxLength": 40, "fieldName": "Shipping Address line 2" },
  "city": { "maxLength": 20, "fieldName": "City" }, 
  "zip": { "maxLength": 15, "fieldName": "Zip Code" },
  "patientName": { "maxLength": 40, "fieldName": "Patient Name" },
  "notes": { "maxLength": MaxInputLength, "fieldName": "Ohter Notes" },
  "itemsSentIn": { "maxLength": MaxInputLength, "fieldName": "Items sent with Order" },
  "shapeCreationNotes": { "maxLength": MaxInputLength, "fieldName": "Measurement Notes" },
  "customerSuppliedPlate": { "maxLength": MaxInputLength, "fieldName": "Customer Supplied Plate Name" },
  "customerSuppliedLock": { "maxLength": MaxInputLength, "fieldName": "Customer Supplied Lock Name" },
  "customerSuppliedValve": { "maxLength": MaxInputLength, "fieldName": "Customer Supplied Valve Name" },
  "customerSuppliedFabric": { "maxLength": MaxInputLength, "fieldName": "Customer Supplied Fabric Name" },
  "additionalRevoFitWindows": { "maxLength": 7, "fieldName": "Additional Window Quantity" },
  "linerPartNumber": { "maxLength": 30, "fieldName": "Part Number" },
  "footPartNumber": { "maxLength": 15, "fieldName": "Part Number" },
  "LinerQuantity": { "maxLength": 9, "fieldName": "Liner Quantity" },
  "footQuantity": { "maxLength": 9, "fieldName": "Quantity" },
  "Quantity": { "maxLength": 9, "fieldName": "Quantity" },
  "Length": { "maxLength": 5, "fieldName": "Length (cm)" },
  "DistalCircumference": { "maxLength": 5, "fieldName": "Distal Circumference (cm)" },
  "MPTCircumference": { "maxLength": 5, "fieldName": "MPT Circumference (cm)" },
  "duplicateLinerPartNumber": { "maxLength": 10, "fieldName": "Serial Number" },
  "linerQuantityDuplicate": { "maxLength": 10, "fieldName": "Duplicate Design Liner Quantity" },
  "highestCircumference": { "maxLength": 5, "fieldName": "Highest Circumference" },
  "lengthToHighest": { "maxLength": 5, "fieldName": "Length To Highest" },
  "residualLength": { "maxLength": 5, "fieldName": "Residual Length" },
  "totalLength": { "maxLength": 5, "fieldName": "Total Length" },
  "linerQuantityNew": { "maxLength": 9, "fieldName": "New Design Liner Quantity" },
  "baseLinerThickness": { "maxLength": 5, "fieldName": "Base Liner Thickness" },
  "distalThickness": { "maxLength": 5, "fieldName": "Distal Thickness" },
  "proximalThickness": { "maxLength": 5, "fieldName": "Proximal Thickness" },
  "posteriorThickness": { "maxLength": 5, "fieldName": "Posterior Thickness" },
  "medialThickness": { "maxLength": 5, "fieldName": "Medial Thickness" },
}

export const ProductsAdded = async (formTypeId, uniqueId) => {
  let accountNumber = localStorage.getItem("accountNumber");

  let parentAccountNumber = localStorage.getItem("parentAccount");
  if (parentAccountNumber) {
    accountNumber = parentAccountNumber;
  }

  const hasMultiProductPermission = await GetAccountPermission(accountNumber, "MULTI_PRODUCT_LINERS");

  if (!hasMultiProductPermission) {
    return null;
  }

  let config = { headers: {} };

  if (uniqueId != null) {
    config.headers.UniqueId = uniqueId;
  }

  config.params = {
    fieldNames: [
      "AddedFormTypeIDs"
    ],
  };

  const result = await apiClient.get(
    "fieldInputs/" + formTypeId,
    config
  )

  let currentAddedFormTypeIDs = result?.data?.find((fi) => fi.fieldName === "AddedFormTypeIDs")?.stringData ?? "";
  return checkIsMulti(currentAddedFormTypeIDs);
}

const checkIsMulti = (productsAdded) => {
  return (productsAdded && productsAdded !== '') ? true : null
}

export const MultiFormNames = {
  15: "Feet",
  14: "Liners"
}

export const OnFileChange = (e, self) => {
  const file = e.target.files[0];
  if (file === undefined) {
    return null;
  }
  if (file.size > 10485760) {
    CreateNotification("Max file size: 10MB", "error");
    return null;
  }
  let formState = self.state.formState;
  const previouslyUploadedFileName = formState.cadFileName.value;
  formState.cadFileName.value = "";
  const newFileName = RenameFile(file, self);
  if (newFileName !== null) {
    formState.cadFile.value = newFileName;
    formState.cadFile.isRequired = self.isFromCADFileSelected();
  } else {
    formState.cadFileName.value = previouslyUploadedFileName;
  }
  self.setState({ formState: formState, hasDataChanged: true });
}

const RenameFile = (file, self) => {
  const oldName = file?.name;
  if (oldName === undefined) {
    return null;
  }
  const oldFileType = oldName.split(".").slice(-1)[0];
  if (ValidFileTypes(oldFileType)) {
    const newName = Date.now() + "_" + (self.state?.patientInfo?.patientId ?? "attachment") + "." + oldFileType;
    self.state.formState.cadFileName.value = newName;
    return new File([file], newName);
  } else {
    CreateNotification("File type must be .stl, .obj or .aop", "error");
    return null;
  }
}

const ValidFileTypes = (oldFileType) => {
  return (oldFileType === 'stl' || oldFileType === 'obj' || oldFileType === 'aop')
}